import type { Source } from './answers';

/** Whether a source row refers to a MIMS monograph (partner key or proxy URL path). */
export function isMimsPartnerSource(
  partnerType?: string | null,
  url?: string | null
): boolean {
  return partnerType === 'mims' || !!url?.includes('/integration-partners/mims/');
}

/** Infer `{ mode: 'html' }` when BE omits embed on MIMS integration-partner rows. */
export function resolveMimsHtmlEmbed(
  embed: Source['embed'] | undefined,
  partnerType?: string | null,
  url?: string | null
): Source['embed'] | undefined {
  if (embed) return embed;
  return isMimsPartnerSource(partnerType, url) ? { mode: 'html' } : undefined;
}
